import { render, staticRenderFns } from "./VoiceSetting.vue?vue&type=template&id=9b07e3aa&scoped=true"
import script from "./VoiceSetting.vue?vue&type=script&lang=js"
export * from "./VoiceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b07e3aa",
  null
  
)

export default component.exports